export enum CONTRACT_TYPE {
  AVERAGE_PRICING = "Average",
  DELAYED_PRICING = "Delayed",
  FORWARD_PRICING = "Forward",
}
